import cookieUtil from 'tradera-utils/cookie';
import { SHIPPING_COUNTRY } from 'tradera-constants/cookies';
import { fetchAvailableShippingCountries } from './api';
import {
    selectIsLoadingAvailableShippingCountries,
    selectHasLoadedAvailableShippingCountries
} from './selectors';

import {
    setShippingCountry,
    setAvailableShippingCountries,
    beginLoadingAvailableShippingOptions,
    setDefaultShippingCountry
} from './reducer';
import { setPreferredCurrency } from 'tradera-state/multi-currency';
import { setPreferredLanguage } from 'tradera-state/language/actions';
import { Analytics } from 'packages';
import { getLanguageFromCountryCode } from 'tradera-utils/languagecode';

const yearInMilliseconds = 1000 * 60 * 60 * 24 * 365;

export const updateShippingRegion = countryCodeIso2 => dispatch => {
    const expireDate = new Date(new Date().getTime() + yearInMilliseconds);
    cookieUtil.createCookie(SHIPPING_COUNTRY, countryCodeIso2, expireDate);

    dispatch(setShippingCountry({ countryCodeIso2 }));
};

export const removeShippingCountryCookieIfSwedish = geolocation => dispatch => {
    if (
        geolocation.isoCode === 'SE' &&
        cookieUtil.hasCookie(SHIPPING_COUNTRY)
    ) {
        cookieUtil.eraseCookie(SHIPPING_COUNTRY);
        dispatch(setDefaultShippingCountry());
    }
};

export const getAvailableShippingCountries = () => async (
    dispatch,
    getState
) => {
    if (
        selectIsLoadingAvailableShippingCountries(getState()) ||
        selectHasLoadedAvailableShippingCountries(getState())
    ) {
        return;
    }

    dispatch(beginLoadingAvailableShippingOptions());
    const { shippingCountries } = await fetchAvailableShippingCountries();
    dispatch(setAvailableShippingCountries({ shippingCountries }));

    if (cookieUtil.hasCookie(SHIPPING_COUNTRY)) {
        dispatch(
            setShippingCountry({
                countryCodeIso2: cookieUtil.readCookie(SHIPPING_COUNTRY)
            })
        );
    }
};

export const onLocalizationShippingRegionSelected = ({
    countryCodeIso2,
    currencyCode,
    toLocalizedUrl
}) => dispatch => {
    const languageCodeIso2 = getLanguageFromCountryCode(countryCodeIso2);

    Analytics.trackEvent({
        category: 'Top navigation',
        action: 'Localization menu tooltip',
        label: `Set localization region - ${countryCodeIso2}`
    });

    dispatch(getAvailableShippingCountries()); //make sure we have loaded countries
    dispatch(updateShippingRegion(countryCodeIso2));
    dispatch(setPreferredCurrency(currencyCode));
    dispatch(setPreferredLanguage(languageCodeIso2, toLocalizedUrl));
};
